// extracted by mini-css-extract-plugin
export default {"footer__section":"styles_footer__section__BRXIf","footer":"styles_footer__dTdTL"};